var __defProp = Object.defineProperty;
var __name = (target, value) => __defProp(target, "name", { value, configurable: true });
import React from "react";
import { FormSelect, FormSelectOption } from "@riseart/form";
import { CartSummaryListRowLine } from "./List.js";
import { cartSummaryListCellPaddedCls, cartSummaryListLabelCls, cartSummarySelectCls, cartSummarySelectLabelCls, cartSummarySelectInputCls } from "./Summary.less";
function CartSummaryShipping(_ref) {
  var translations = _ref.translations, onShippingChange = _ref.onShippingChange, formatMessage = _ref.formatMessage, countryCodeList = _ref.countryCodeList, _ref$currentShippingC = _ref.currentShippingCountryCode, currentShippingCountryCode = _ref$currentShippingC === void 0 ? null : _ref$currentShippingC, canEditShipping = _ref.canEditShipping, isShippingFree = _ref.isShippingFree, shippingAmount = _ref.shippingAmount, currencyFormatter = _ref.currencyFormatter, _ref$shippingAddress = _ref.shippingAddress, shippingAddress = _ref$shippingAddress === void 0 ? null : _ref$shippingAddress;
  return /* @__PURE__ */ React.createElement(CartSummaryListRowLine, null, /* @__PURE__ */ React.createElement("div", null, /* @__PURE__ */ React.createElement("span", {
    className: cartSummaryListLabelCls
  }, translations.shipping), canEditShipping ? /* @__PURE__ */ React.createElement("span", {
    className: cartSummarySelectCls
  }, /* @__PURE__ */ React.createElement("span", {
    className: cartSummarySelectLabelCls
  }, translations.to), /* @__PURE__ */ React.createElement(FormSelect, {
    getPopupContainer: /* @__PURE__ */ __name(function getPopupContainer(triggerNode) {
      return triggerNode.parentElement;
    }, "getPopupContainer"),
    defaultValue: currentShippingCountryCode || shippingAddress && shippingAddress.countryCode,
    className: cartSummarySelectInputCls,
    onChange: onShippingChange
  }, countryCodeList.map(function(countryCode) {
    return /* @__PURE__ */ React.createElement(FormSelectOption, {
      key: countryCode,
      value: countryCode
    }, formatMessage({
      id: "countries.".concat(countryCode)
    }));
  }))) : null), /* @__PURE__ */ React.createElement("div", canEditShipping ? {
    className: cartSummaryListCellPaddedCls
  } : null, isShippingFree ? translations.freeShipping : currencyFormatter(shippingAmount)));
}
__name(CartSummaryShipping, "CartSummaryShipping");
export {
  CartSummaryShipping
};
